import React from 'react';
import { useDispatch } from 'react-redux';
import './FormTextInput.scss';
import RequiredStar from '../RequiredStar/RequiredStar';
import { removeFormFieldError } from '../../redux/actions/contentActions';

const FormTextInput = (props) => {
    const dispatch = useDispatch();


    
    var inputClasses = 'form-text-input';
    if(props.full) inputClasses += " full";
    if(props.topPad) inputClasses += " top-padding";


    if(props.conditional) {
        inputClasses += " conditional";

        var condActive = false;
        if(typeof props.cond_value !== 'undefined' && typeof props.cond_field !== 'undefined') {
            if(Array.isArray(props.cond_value)) {
                for(var i = 0; i < props.cond_value.length; i++) {
                    if(props.cond_value[i] == props.cond_field) {
                        //its conditional and should be shown if we get a match
                        condActive = true;
                    }
                }
            }
            else {
                if(props.cond_value == props.cond_field)
                    condActive = true;
            }
        }

        if(condActive) {
            inputClasses += " cond_active";
        }
    }

    const onTextInputChange = (e) => {
        const value = e.target.value;
        props.setFormValue({ ...props.formValue, [e.target.name]: value });
        if (props.error) {
            dispatch(removeFormFieldError(props.index));
        }
    };

    return (
        <div className={inputClasses}>
            <label htmlFor={props.id}>
                {props.label}
                {props.required && <RequiredStar />}
            </label>
            <input
                type={props.email ? 'email' : 'text'}
                placeholder={props.placeholder}
                onChange={onTextInputChange}
                name={props.name}
                className={props.error ? 'text-input-error' : ''}
            />
        </div>
    );
};

export default FormTextInput;
